<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  OIDCWarden Web<br />
  {{ "versionNumber" | i18n: version }}
</footer>
